import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReqFiltersPageComponent } from './req-filters-page.component';
import { ReqFiltersPageRoutingModule } from './req-filters-page.routing.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
    declarations: [ReqFiltersPageComponent],
    imports: [
        CommonModule,
        ReqFiltersPageRoutingModule,
        FlexLayoutModule,
        MatCardModule,
        MatButtonModule,
    ],
    exports: [ReqFiltersPageComponent],
})
export class ReqFiltersPageModule {}
